var _text, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIfc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 12,
    y: 13,
    textAnchor: "middle",
    fontSize: 9,
    fontWeight: 700,
    fontFamily: "Arial, Helvetica, sans-serif",
    fill: "currentColor"
  }, "\r\n    IFC\r\n  ")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 18 Q4.5 15.5 7 18 T12 18 T17 18 T22 18",
    stroke: "#E53935",
    strokeWidth: 1.8,
    fill: "none",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIfc);
export default __webpack_public_path__ + "static/media/IFC.ef6649ba3f3962011a370d4043f9d967.svg";
export { ForwardRef as ReactComponent };